import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import FaqSection from '../FaqSection';
import HeroSection from '../HeroSection';
// import FaqBg from "../images/acfan.jpg";


function FAQ() {
 
  return (
    <div className='container-fluid px-0 pt-5'>
  <div
      style={{
        backgroundImage: `url(https://swastikengineers.net/static/media/acfan.ffd0da379b93a2b40ba6.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        minHeight: "150px", // mobile friendly chhota height
        paddingTop: "30px", // desktop: 50px, mobile: 30px
        paddingBottom: "30px",
        position: "relative",
        color: "white",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1,
        }}
      ></div>

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center",
          padding: "0 15px",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(1.2rem, 5vw, 2rem)", // smaller font for mobile
            fontWeight: "700",
            color:"white",
                 margin: "3.5rem 0",
          }}
        >
          Frequently Asked Questions
        </h1>
        <p
          style={{
            fontSize: "clamp(1.2rem, 2.5vw, 1rem)", // smaller font for mobile
            margin: "2.5rem 0",
            color:"white",  

          }}
        >
          Find answers to common questions about our programs, teachings, and values. We’re here to help you understand how PSF guides you toward knowledge, discipline, and a meaningful life rooted in Sanatan Dharma.
        </p>

        {/* Breadcrumbs */}
        <nav aria-label="breadcrumb">
          <ol
            style={{
              listStyle: "none",
              display: "flex",
              justifyContent: "center",
              padding: 0,
              margin: 0,
            }}
          >
            <li style={{ marginRight: "5px" }}>
              <Link to="/" style={{ color: "white", textDecoration: "none" }}>
                Home
              </Link>
              <span style={{ margin: "0 5px" }}>/</span>
            </li>
            <li style={{ color: "white" }}>Frequently Asked Questions</li>
          </ol>
        </nav>
      </div>
    </div>





      <FaqSection/>
      <HeroSection/>
    </div>
  )
}

export default FAQ
